import React from 'react';
import config from '@drs/config';
import CustomizationContext from '../CustomizationContext';
import RoadshowContext from '@drs/roadshow-context';
import Layout from './Layout';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';

const LandingLayout = ({ children }) => (
  <RoadshowContext>
    <CustomizationContext>
      <Layout>
        <ScrollBodyBackground tenant={ config.code } />
        { children }
      </Layout>
    </CustomizationContext>
  </RoadshowContext>
);

export default LandingLayout;
